import script from "./AccordionItemWithDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./AccordionItemWithDropdown.vue?vue&type=script&setup=true&lang=js"

import "./AccordionItemWithDropdown.vue?vue&type=style&index=0&id=e243089a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e243089a"]])

export default __exports__